module.exports = "<router-outlet></router-outlet>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/calculator/calculator-item/individual-calculator/individual-travel/individual-travel.component.html
// module id = ./src/app/components/calculator/calculator-item/individual-calculator/individual-travel/individual-travel.component.html
// module chunks = main